import Clarity from "@microsoft/clarity";
import { useEffect } from "react";

export default function MicrosoftClarityScript() {
    useEffect(() => {
        if (import.meta.env.PROD) {
            const projectId = "qpr2s8uxfw";
            Clarity.init(projectId);
        }
    });

    return null;
}
